// api
import type {
  CreateAlarmGroupDto,
  CreateAlarmSubscriptionDto,
  WriteAlarmInclusionDto,
} from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import type { CreateAlarmGroupFormValues } from './createAlarmGroupForm.schema';

export type AlarmGroupUserOption = {
  User?: {
    UserId?: number;
    Email?: string;
  };
};

export const DEFAULT_ALARM_GROUP_SUBSCRIPTION: CreateAlarmGroupFormValues['users'][number] =
  {
    user: '',
    feedSeverity: 'Information',
    emailSeverity: 'Information',
  };

export function toCreateAlarmGroupFormValues(): CreateAlarmGroupFormValues {
  return {
    groupName: '',
    users: [DEFAULT_ALARM_GROUP_SUBSCRIPTION],
    alarmTypes: [],
  };
}

export function toCreateAlarmGroupDto(
  values: CreateAlarmGroupFormValues,
  selectedAccountId: number,
  userOptions: AlarmGroupUserOption[],
): CreateAlarmGroupDto {
  const alarmSubscriptions: CreateAlarmSubscriptionDto[] = values.users
    .filter((subscription) => Boolean(subscription.user))
    .map((subscription) => {
      const matchedUser = userOptions.find(
        (option) => option.User?.Email === subscription.user,
      );

      if (!matchedUser?.User?.UserId) {
        return null;
      }

      return {
        User: { UserId: matchedUser.User.UserId },
        FeedSeverity: subscription.feedSeverity,
        EmailSeverity: subscription.emailSeverity,
      };
    })
    .filter((subscription): subscription is CreateAlarmSubscriptionDto =>
      Boolean(subscription),
    );

  const alarmInclusions: WriteAlarmInclusionDto[] = values.alarmTypes.map(
    (alarmTypeId) => ({
      AlarmType: { AlarmTypeId: alarmTypeId },
    }),
  );

  return {
    Name: values.groupName.trim(),
    Account: { AccountId: selectedAccountId },
    AlarmSubscriptions: alarmSubscriptions,
    AlarmInclusions: alarmInclusions,
  };
}
